import { MapObject } from "./map-object";

export class PJ extends MapObject {
    
    constructor(public id:number, public longitude:number, public latitude:number, public altitude:number,
        public content:String, public label:String, public tmbImg:String, public bigImg:String
    ) {
        super(id, longitude, latitude, label)
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/pj.ts